import { Dialog, AppBar, DialogActions, Button, WithStyles, createStyles, Theme, withStyles, DialogContent, Typography, Toolbar } from '@material-ui/core';
import * as React from 'react';
import { AuthContext } from '../authentication/AuthContext';

const styles = (theme: Theme) =>
  createStyles({
  });
export interface HandlePasswordResetProps extends WithStyles<typeof styles> {
  open: boolean;
  handleOpen: (isOpen: boolean) => void;
}

const contentWrapper = {
  margin: '40px 16px',
}

enum PasswordRequestState {
  NotRequested,
  InProgress,
  Completed,
  Failed,
  PreviouslyRequested
}

function HandlePasswordReset(props: HandlePasswordResetProps) {
  const { classes, open, handleOpen } = props;
  const [passwordRequest, setPasswordRequest] = React.useState(PasswordRequestState.NotRequested);
  const authContext = React.useContext(AuthContext);

  const changePasswordCallback = (success: boolean) => {
    if (success) {
      setPasswordRequest(PasswordRequestState.Completed);
    } else {
      setPasswordRequest(PasswordRequestState.Failed);
    }
  }


  const handleChangePasswordClick = () => {
    if (passwordRequest === PasswordRequestState.NotRequested || PasswordRequestState.PreviouslyRequested) {
      setPasswordRequest(PasswordRequestState.InProgress);
      authContext.changePassword(changePasswordCallback);
    } else {
      handleOpen(false);
    }
  }

  const handleCancelClick = () => {
    if (passwordRequest === PasswordRequestState.Completed) {
      setPasswordRequest(PasswordRequestState.PreviouslyRequested);
    } else {
      setPasswordRequest(PasswordRequestState.NotRequested);
    }
    handleOpen(false);
  }

  let dialogText: string;
  switch (passwordRequest) {
    case PasswordRequestState.NotRequested:
      dialogText = 'Are you sure you want to change your password?'
      break;
    case PasswordRequestState.PreviouslyRequested:
      dialogText = 'Send another request to change your password?'
      break;
    case PasswordRequestState.InProgress:
      dialogText = 'Connecting to server...'
      break;
    case PasswordRequestState.Completed:
      dialogText = 'Request sent, you will receive an email shortly.'
      break;
    case PasswordRequestState.Failed:
      dialogText = 'An error has occurred, please contact us at: https://www.deltaxml.com/contact/'
      break;
  }

  const enableConfirmButton = passwordRequest === PasswordRequestState.NotRequested || passwordRequest === PasswordRequestState.PreviouslyRequested;
  const changePasswordButtonDialog = passwordRequest === PasswordRequestState.Completed ? 'OK' : 'Cancel'

  return (
    <div style={contentWrapper}>
      <Dialog open={open} onClose={() => { handleOpen(false) }}>
        <AppBar position="static">
        <Toolbar>
          <Typography variant="h4">Change Password</Typography>
        </Toolbar>
        </AppBar>
        <br />
        <DialogContent>
          <Typography variant="body1" color="textSecondary">{dialogText}</Typography>
        </DialogContent>
        <DialogActions>
          {enableConfirmButton
            ? <Button variant="contained" color="primary" onClick={handleChangePasswordClick}>
              Confirm
            </Button>
            : null
          }
          <Button variant="contained" color="primary" onClick={handleCancelClick}>
            {changePasswordButtonDialog}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
};

export default withStyles(styles)(HandlePasswordReset);